<template>
  <div>
    <div class="document-container">
      <div class="document">
        <div class="header">
          <EsHeader>
            <template #header>
              <div class="header-title">General</div>
              <div class="header-subtitle">
                View/edit general profile information
              </div>
            </template>
            <template #actions>
              <ul>
                <span class="is-primary">
                  <li class="p-narrow no-border">
                    <div class="list-content">
                      <font-awesome-icon
                        class="edit-icon"
                        title="Edit"
                        :icon="['fas', 'edit']"
                        v-if="editing === false"
                        @click="toggleEditing"
                        size="1x"
                      />
                    </div>
                  </li>
                </span>
              </ul>
            </template>
          </EsHeader>
        </div>
        <div class="content">
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'sitemap']"/>
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    Group Details
                  </h6>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Group Name</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input"
                          :class="{ 'is-static': !editing ,'is-danger': hasErrorLabel}"
                          type="text" placeholder="Group Name" :readonly="!editing"
                          v-model="label">
                          <p class="help is-danger"> {{labelMsg}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Code {{editing ? '(optional)' : ''}}</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input class="input"
                          :class="{ 'is-static': !editing ,'is-danger': hasErrorCode}"
                          type="text" placeholder="Code" :readonly="!editing"
                          v-model="code">
                          <p class="help is-danger">{{ codeMsg }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Description {{editing ? '(optional)' : ''}}</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <p class= "description-static" v-if ="!editing">{{description}}</p>
                        <textarea class="textarea" :class="{ 'is-danger': hasErrorDescription}"
                          type="text" placeholder="Description"
                          v-model="description" rows="2" v-if ="editing">
                       </textarea>
                      </div>
                        <p class="help is-danger">{{ descriptionMsg }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Organization</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <div class="control">
                        <input class="input is-static"
                          type="text" placeholder="Name" readonly
                          :value="organizationCode">
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Status</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control" v-if="!editing">
                        <input
                          v-if="active"
                          class="input"
                          type="text"
                          :class="{ 'is-static': !editing}"
                          :readonly="!editing"
                          value="Active">
                        <input
                          v-else
                          class="input"
                          type="text"
                          :class="{ 'is-static': !editing}"
                          :readonly="!editing"
                          value="Inactive">
                      </div>
                      <div
                        v-else
                        class="control">
                        <input class="is-checkradio"
                          id="groupProfileDetailsActiveTrue"
                          type="radio"
                          name="answer"
                          :value="true"
                          v-model="active">
                        <label class="radio"
                          for="groupProfileDetailsActiveTrue">
                          Active
                        </label>
                        <input class="is-checkradio"
                          id="groupProfileDetailsActiveFalse"
                          type="radio"
                          name="answer"
                          :value="false"
                          v-model="active">
                        <label class="radio"
                          for="groupProfileDetailsActiveFalse">
                          Inactive
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <es-form>
            <template #es-form-header>
              <div class="header-container">
                <div class="header-elements">
                  <font-awesome-icon :icon="['fas', 'map-marker-alt']"/>
                </div>
                <div class="header-elements">
                  <h6 class="title">
                    More
                  </h6>
                </div>
              </div>
            </template>
            <template #es-form>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Last Updated</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static" readonly
                      :value="group.lastUpdateDate | formatDateMMDDYYYY">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Last Updated By</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static" readonly
                      :value="lastUpdatedBy">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Created</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static" readonly
                      :value="group.createdDate | formatDateMMDDYYYY">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" :class="{ removeUnderline: editing }">
                <div class="field is-horizontal">
                  <div class="field-label is-normal">
                    <label class="label">Created By</label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <input class="input is-static" readonly
                      :value="createdBy">
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </es-form>
          <div class="es-actions" v-if="editing">
            <EsFormActions>
              <template #form-actions>
                <div class="bottom-content">
                  <ul>
                    <li>
                      <div class="list-content">
                        <a @click="clearAll">Cancel</a>
                      </div>
                    </li>
                    <li>
                      <div class="list-content">
                        <button
                          class="button is-primary"
                          @click.stop.prevent="formValidation">
                            Update
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </EsFormActions>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEdit,
  faMapMarkerAlt,
  faSitemap,
} from '@fortawesome/pro-solid-svg-icons';

import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faEdit,
  faMapMarkerAlt,
  faSitemap,
);
export default {
  mixins: [NotificationManager],
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
  },
  data() {
    return {
      editing: false,
      code: null,
      description: null,
      label: null,
      active: true,
      organizationCode: null,
      groupInfo: null,
      group: {},
      organizations: [],
      messages: [],
      hasErrorLabel: false,
      hasErrorCode: false,
      hasErrorDescription: false,
      hasErrorOrganization: false,
      hasErrorAPI: false,
      labelMsg: '',
      codeMsg: '',
      descriptionMsg: '',
      organizationMsg: '',
      apiMsg: '',
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
    };
  },
  mounted() {
    this.getGroup();
    this.getOrganizations();
  },
  computed: {
    lastUpdatedBy() {
      if (this.group.lastUpdateUser !== undefined) {
        return `${this.group.lastUpdateUser.firstName} ${this.group.lastUpdateUser.lastName}`;
      }
      return '';
    },
    createdBy() {
      if (this.group.createdByUser !== undefined) {
        return `${this.group.createdByUser.firstName} ${this.group.createdByUser.lastName}`;
      }
      return '';
    },
  },
  methods: {
    toggleEditing() {
      this.editing = !this.editing;
    },
    async getOrganizations() {
      try {
        const res = await axios.get('organizations');
        this.organizations = res.data;
      } catch {
        // handle error
      }
    },
    async getGroup() {
      try {
        const { groupId } = this.$route.params;
        const res = await axios.get(`location-groups/${groupId}`);
        this.group = res.data;
        this.setGroupValues();
      } catch (error) {
        // handle error
      }
    },
    setGroupValues() {
      this.code = this.group.code;
      this.description = this.group.description;
      this.label = this.group.label;
      this.organizationCode = this.group.organizationCode;
      this.active = this.group.active;
    },
    async updateGroup() {
      try {
        const { groupId } = this.$route.params;
        await axios.put(`location-groups/${groupId}`, ({
          code: this.code,
          description: this.description,
          label: this.label,
          active: this.active,
          organizationCode: this.organizationCode,
        }));
        this.toggleEditing();
        this.refreshHeader();
        this.showNotification('success', ['The group profile has been updated successfully.']);
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error' : error.response.data.message}`;
        this.messages.push(this.apiMsg);
        this.showNotification('danger', [error.response.data.message]);
      }
    },
    refreshHeader() {
      this.$emit('updated');
    },
    async formValidation() {
      this.resetErrors();
      let errors = 0;
      this.messages = [];
      if (!this.label.trim()) {
        errors += 1;
        this.labelMsg = 'Group Name is required.';
        this.hasErrorLabel = true;
      } else if (this.label.trim().length > 25) {
        errors += 1;
        this.labelMsg = 'Group Name cannot be exceed 25 characters.';
        this.hasErrorLabel = true;
      } else {
        this.label = this.label.trim();
      }
      if (this.code) {
        if (this.code.trim().length > 5) {
          errors += 1;
          this.codeMsg = 'Group Code cannot be exceed 5 characters.';
          this.hasErrorCode = true;
        } else {
          this.code = this.code.trim();
        }
      }
      if (this.description) {
        if (this.description.trim().length > 128) {
          errors += 1;
          this.descriptionMsg = 'Description cannot be exceed 128 characters.';
          this.hasErrorDescription = true;
        } else {
          this.description = this.description.trim();
        }
      }
      if (!this.organizationCode) {
        errors += 1;
        this.organizationMsg = 'Organization is required.';
        this.hasErrorOrganization = true;
      }
      if (errors > 0) {
        this.messages.push(this.formErrorMsg);
        this.showNotification('danger', this.messages);
      } else {
        this.updateGroup();
      }
    },
    resetErrors() {
      this.messages = [];
      this.hasErrorLabel = false;
      this.hasErrorOrganization = false;
      this.hasErrorCode = false;
      this.hasErrorDescription = false;
      this.hasErrorAPI = false;
      this.labelMsg = '';
      this.codeMsg = '';
      this.descriptionMsg = '';
      this.organizationMsg = '';
      this.apiMsg = '';
    },
    clearAll() {
      this.toggleEditing();
      this.resetErrors();
      this.hideNotification();
      this.getGroup();
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    max-width: 960px
  .edit-icon
    cursor: pointer
    &:hover
      color: #474282
</style>
